import gmx_zMixins         from '../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

import lmx_Elements from './Draw_Elements.mixin'          // Common functions for Drawing the Charts

// Charting
import lmx_Embossed from './Chart_Embossed.mixin'
import lmx_Cylinder from './Chart_Cylinder.mixin'
import lmx_Tube from     './Chart_Tube.mixin'
import lmx_Boxes from    './Chart_Boxes.mixin'
import lmx_Delta from    './Chart_Delta.mixin'

export default {
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_Watching,
    lmx_Events,
    
    // Charting Mixins
    lmx_Elements,
    lmx_Embossed,
    lmx_Cylinder,
    lmx_Tube,
    lmx_Boxes,
    lmx_Delta,
  ],
}
